import $ from "jquery";
import './../packages/jquery-ui-1.12.1/jquery-ui.js';
import './../sass/app.scss';
import './navigation.js';


(function($){ //create closure so we can safely use $ as alias for jQuery
$(document).ready(function(){

  $('.page_item_has_children').on('click', function (e) {
    e.stopPropagation();

    if($(e.target).hasClass('current_page_item')) {return;}
    if($(e.target).hasClass('current_page_parent')) {return;}
    if($(e.target).hasClass('current_page_ancestor')) {return;}

    if($(e.target).hasClass('open')) {
      $(e.target).children('ul:first').fadeOut(120).hide(100);
      $(e.target).removeClass('open');
    } else {
      setTimeout(function(){
        $(e.target).addClass('open');
        $(e.target).children('ul:first').fadeIn(120).show(100);
      },100);
    }
  });
  $('.menu-item-has-children').on('click', function (e) {
    e.stopPropagation();

    if($(e.target).hasClass('current-menu-item')) {return;}
    if($(e.target).hasClass('current-menu-parent')) {return;}
    if($(e.target).hasClass('current-menu-ancestor')) {return;}

    if($(e.target).hasClass('open')) {
      $(e.target).children('ul:first').fadeOut(120).hide(100);
      $(e.target).removeClass('open');
    } else {
      setTimeout(function(){
        $(e.target).addClass('open');
        $(e.target).children('ul:first').fadeIn(120).show(100);
      },100);
    }
  });


  /**
   * main navigation search toggle functionality
   */
  $('.main-nav .search-submit').on('click', function(e) {
    e.preventDefault();
    var searchContainer = $('.search-area');
    var searchForm = $('.search-form');
    var searchField = $('.search-field');
    if(searchContainer.hasClass('hidden')) {
      searchContainer.removeClass('hidden');
      searchField.focus();
    } else {
      searchForm.submit();
    }
  });
  $('.main-nav .search-close').on('click', function(e) {
    var searchContainer = $('.main-nav .search-area');
    searchContainer.addClass('hidden');
  });
  /**
   * if multiple search fields exist make sure input is equal
   */
  $('.search-field').on('blur', function() {
    $('.search-field').val(this.value);
  });

  /**
   * accordions - jquery ui
   */
  $( ".sc-accordion" ).accordion({
    heightStyle: "content",
    animate: 700,
    collapsible: true,
    active: false,
    icons: false,
  });
  $( ".readmorepage" ).accordion({
    heightStyle: "content",
    animate: 700,
    collapsible: true,
    active: false,
    icons: false,
    header: "h2[rm]",
  });

  /**
   * tabs - jquery ui
   */
  $( ".sc-tabs" ).tabs();

});
})(jQuery);



// WEBPACK FOOTER //
// ./js/app.js